import FastJobDialogs from '@/weon/models/FastJobDialogs';
import {
  RESET_FAST_JOB_DIALOGS,
  SET_DIALOG_FAST_JOB,
} from '@/store/mutation-types.js';

const mutations = {
  [SET_DIALOG_FAST_JOB](state, value) {
    state.dialogFastJob = value.dialog;
    state.fastJobDialogVoiceNumber = value.number;
  },

  [RESET_FAST_JOB_DIALOGS](state) {
    state = new FastJobDialogs();
  },
};

export default mutations;
